require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./affaires-gouvernementales-0-2-2.json") })
        }
      }, "path---affaires-gouvernementales-0-2-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---affaires-gouvernementales-0-2-2!./.cache/json/affaires-gouvernementales-0-2-2.json
// module id = 320
// module chunks = 231608221292675